// src/icons/ArrowUpRight.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function ArrowUpRight({
  strokeWidth = "2.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22.4167 17.4167V1.58333M22.4167 1.58333H6.58333M22.4167 1.58333L2 22",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap,
          strokeLinejoin
        }
      )
    }
  );
}

export {
  ArrowUpRight
};
